export class Scope {
  scope: string;
  editableFields: string[];
}
